import { render } from "./PreviewText.vue?vue&type=template&id=39a05666&scoped=true"
import script from "./PreviewText.vue?vue&type=script&lang=js"
export * from "./PreviewText.vue?vue&type=script&lang=js"

import "./PreviewText.vue?vue&type=style&index=0&id=39a05666&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a05666"]])

export default __exports__